var React = require('react');

function ExclamationCircleIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"currentColor","cx":"12","cy":"12","r":"10","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"m12 17.046a1.128 1.128 0 1 1 1.128-1.128 1.079 1.079 0 0 1 -1.128 1.128zm0-3.268c-.6 0-.67-.225-.7-.642-.321-4.17-.383-5.332-.383-5.5 0-.274.15-.581 1.087-.581s1.087.307 1.087.581c0 .171-.062 1.333-.383 5.5-.038.417-.108.642-.708.642z","key":1})]);
}

ExclamationCircleIcon.defaultProps = {"data-dmid":"dm-exclamation-circle-filled","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = ExclamationCircleIcon;

ExclamationCircleIcon.default = ExclamationCircleIcon;
